import { FormProvider } from "react-hook-form";
import { Button } from "primereact/button";
import { ITopicFormProps } from "./Topic.model";
import { FormRow } from "../../components/FormRow";
import { CustomInput } from "../../components/CustomInput";
import { CustomSelect } from "../../components/CustomSelect";
import { InputTextarea } from "primereact/inputtextarea";
import { Controller } from "react-hook-form";
import { STATUS_OPTIONS } from "../../library/utilities/constants/constant";

const TopicForm = ({ methods, onSubmit, isEdit }: ITopicFormProps) => {
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} className="p-fluid">
        <FormRow label="Topic Name *" name="name">
          <CustomInput
            name="name"
            rules={{
              required: "Topic name is required",
              minLength: {
                value: 2,
                message: "Topic name must be at least 2 characters",
              },
            }}
          />
        </FormRow>

        <FormRow label="Description" name="description">
          <Controller
            name="description"
            control={methods.control}
            render={({ field }) => (
              <InputTextarea
                {...field}
                rows={4}
                className="w-full"
                placeholder="Enter topic description"
              />
            )}
          />
        </FormRow>

        <FormRow label="Status *" name="is_active">
          <CustomSelect
            name="is_active"
            options={STATUS_OPTIONS}
            placeholder="Select status"
          />
        </FormRow>

        <div className="mt-4 flex justify-content-end">
          <Button
            label={isEdit ? "Update Topic" : "Create Topic"}
            type="submit"
          />
        </div>
      </form>
    </FormProvider>
  );
};

export default TopicForm;
